<template>
  <o-view class="c-sales-view" :has-white-background="true" :no-scroll="true">
    <o-view :bottom-padding="true">
      <o-nav-bar
        :title="navBarTitle"
        :has-back-button="true"
        :is-overlay="true"
      />
      <o-tabs
        :items="[{ label: 'Privé', isSelected: true }, { label: 'Werk' }]"
        v-if="showBudgets"
      />
      <o-header-image :image="image" />
      <o-section-header :title="title">
        <template #right>
          <o-icon icon="support2" @click.native="toggleSupportOverlay" />
          <o-icon icon="info" @click.native="toggleInfoOverlay" />
        </template>
      </o-section-header>
      <o-tabs :items="tabs" v-if="tabs" />
      <slot name="custom">
        <o-section>
          <div class="c-sales-details">
            <div class="c-sales-details__left">
              <div class="c-mobility-points" v-if="$store.state.showMobilits">
                <div class="c-mobility-points__icon">
                  <o-icon icon="mobility-points" />
                </div>
                <div class="c-mobility-points__value">+ {{ points }}</div>
              </div>
            </div>
            <div class="c-sales-details__center">
              <div class="c-price">
                <span class="c-price__sign">€</span>
                <span class="c-price__value">{{ price }}</span>
              </div>
              <div class="c-service" v-if="serviceCost">
                + €{{ serviceCost }} servicekosten
              </div>
            </div>
            <div class="c-sales-details__right">
              <o-favorite-toggle v-if="$store.state.showFavoriteButton" />
            </div>
          </div>
          <o-alert v-if="message" :message="message" />
        </o-section>
        <slot />
        <o-section v-if="$store.state.showPersonalMessage">
          <o-text-input placeholder="Schrijf hier je persoonlijke referentie" />
        </o-section>
      </slot>
    </o-view>
    <o-pay-button @click="toggleKBCOverlay" v-if="showButton" />
    <div
      class="c-bottom-overlay__cover"
      :class="{
        'c-bottom-overlay__cover--show':
          showKBCOverlay || showInfoOverlay || showSupportOverlay
      }"
      @click="closeAllOverlays"
    />
    <div
      class="c-bottom-overlay"
      :class="{
        'c-bottom-overlay--open': showKBCOverlay
      }"
    >
      <o-reseller-badge />
      <o-button label="Bevestigen" :to="nextLink" />
    </div>
    <div
      class="c-bottom-overlay"
      :class="{
        'c-bottom-overlay--open': showInfoOverlay
      }"
    >
      <o-icon
        class="c-bottom-overlay__close"
        icon="close"
        @click.native="toggleInfoOverlay"
      />
      <p class="c-bottom-overlay__text">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut consectetur
        accumsan libero. Nullam quis elit at metus viverra tempor. Vivamus metus
        magna, dapibus at lacus et, tincidunt cursus tellus.
      </p>
    </div>
    <div
      class="c-bottom-overlay"
      :class="{
        'c-bottom-overlay--open': showSupportOverlay
      }"
    >
      <h2 class="c-bottom-overlay__title">Support</h2>
      <o-icon
        class="c-bottom-overlay__close"
        icon="close"
        @click.native="toggleSupportOverlay"
      />
      <div class="c-bottom-overlay__list">
        <o-list-item icon="call" label="Bel de helpdesk" :chevron="false" />
        <o-list-item icon="email" label="Mail de helpdesk" :chevron="false" />
        <o-list-item
          icon="link"
          label="Meest gestelde vragen"
          :chevron="false"
        />
      </div>
    </div>
  </o-view>
</template>

<script>
import OFavoriteToggle from '@/components/OFavoriteToggle.vue'
import OHeaderImage from '@/components/OHeaderImage.vue'
import OPayButton from '@/components/OPayButton.vue'
import OBudgetPicker from '@/components/OBudgetPicker.vue'
import OTabs from '@/components/base/OTabs.vue'
export default {
  name: 'OSalesView',
  components: {
    OTabs,
    OBudgetPicker,
    OFavoriteToggle,
    OHeaderImage,
    OPayButton
  },
  props: {
    title: {
      type: String,
      default: 'Productnaam'
    },
    image: {
      type: String,
      default: '/images/bluebike-header.jpg'
    },
    points: {
      type: Number,
      default: 3
    },
    price: {
      type: String,
      default: '3,30'
    },
    serviceCost: {
      type: String,
      default: null
    },
    tabs: {
      type: Array,
      default: null
    },
    message: {
      type: String,
      default: null
    },
    nextLink: {
      type: String,
      default: '/'
    },
    navBarTitle: {
      type: String,
      default: ''
    },
    showButton: {
      type: Boolean,
      default: true
    },
    showBudgets: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      showKBCOverlay: false,
      showInfoOverlay: false,
      showSupportOverlay: false
    }
  },
  methods: {
    toggleKBCOverlay() {
      this.showKBCOverlay = !this.showKBCOverlay
    },
    toggleInfoOverlay() {
      this.showInfoOverlay = !this.showInfoOverlay
    },
    toggleSupportOverlay() {
      this.showSupportOverlay = !this.showSupportOverlay
    },
    closeAllOverlays() {
      this.showKBCOverlay = false
      this.showInfoOverlay = false
      this.showSupportOverlay = false
    }
  }
}
</script>

<style lang="scss">
.c-sales-view {
  display: flex;
  flex-direction: column;
  min-height: 100%;

  .c-sales-sections {
    flex: 1 0 auto;
  }
}

.c-sales-details {
  padding: 0.8rem 0;
  position: relative;

  &:not(:last-child) {
    margin-bottom: 1.6rem;
  }
}

.c-sales-details__left,
.c-sales-details__right {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.c-sales-details__right {
  right: 0;
}

.c-sales-details__center {
  text-align: center;
}

.c-mobility-points {
  align-items: center;
  display: flex;
}

.c-mobility-points__icon {
  color: $primary-color;
  color: var(--primary-color);
}

.c-mobility-points__value {
  font-size: 1.3rem;
  margin-left: 0.8rem;
}

.c-price {
  color: $primary-color;
  color: var(--primary-color);
  font-size: 3.2rem;
  font-weight: 600;
  line-height: 3.2rem;
}

.c-price__sign {
  color: $gray-500;
  font-weight: 300;
  margin-right: 0.8rem;
}

.c-service {
  color: $gray-500;
  font-size: 1.3rem;
  margin-top: 0.8rem;
}

.c-bottom-overlay {
  background: #fff;
  border-radius: 1.2rem 1.2rem 0 0;
  box-shadow: $box-shadow-large, $box-shadow-large;
  bottom: 0;
  left: 0;
  max-height: 60vh;
  opacity: 0;
  overflow: auto;
  padding: 2.4rem;
  position: absolute;
  right: 0;
  transform: translateY(100%);
  transition: all 0.2s ease-in-out;
  z-index: 20;
}

.c-bottom-overlay__cover {
  background: rgba(#000, 0.4);
  bottom: 0;
  left: 0;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0;
  transition: opacity 0.1s linear;
  z-index: 10;
}

.c-bottom-overlay__cover--show {
  opacity: 1;
  pointer-events: auto;
}

.c-bottom-overlay--open {
  opacity: 1;
  transform: translateY(0);
}

.c-bottom-overlay__title {
  font-weight: 600;
  margin-bottom: 1.6rem;
}

.c-bottom-overlay__text {
  line-height: 2.4rem;
  padding-right: 2.4rem;
}

.c-bottom-overlay__text:not(:last-child) {
  margin-bottom: 1.6rem;
}

.c-bottom-overlay__list {
  margin: 0 -1.6rem;
}

.c-bottom-overlay__close {
  cursor: pointer;
  position: absolute;
  right: 1.6rem;
  top: 1.6rem;
}
</style>
